import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { ImportEmailComponent } from 'app/entities/emails/import-email/import-email.component';
import { EntityEmailsComponent } from 'app/entities/emails/emails.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@angular/material';

import { DataTableModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { EntityEmailService } from 'app/entities/emails/emails.service';


@NgModule({
    declarations: [
        EntityEmailsComponent,
        ImportEmailComponent
    ],
    imports: [
        SharedModule,
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        DataTableModule,
        InfiniteScrollModule,
    ],
    providers: [EntityEmailService],
    entryComponents: [
        ImportEmailComponent
    ]
})

/**
 * Main module for the entity email tab management.
*/
export class EntityEmailModule { }



// WEBPACK FOOTER //
// ./src/app/entities/emails/emails-module.ts